import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import { notification } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import { message } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { update_plan_info, create_plan_info } from '@/api/mjstore-model';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '编辑',
    clazz: 'primary',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '编辑计划',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'require_info__code',
              label: '诉求号',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'remotemodal',
              name: 'project_id',
              label: '计划项目',
              disabled: false,
              placeholder: '请选择计划项目',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-project',
            },
            {
              type: 'input',
              name: 'num',
              label: '计划数量',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写计划数量',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '创建日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              placeholder: '请填写创建日期',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: true,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {},
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            plan_info_id: data.id,
            require_info__code: data.require_info__code,
            project_id: data.project_id,
            num: data.num,
            date: data.date,
            shop_id: data.shop_id,
            staff_id: data.staff_id,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_plan_info({
              ...payload,
            })
              .then(() => {
                notification.success({
                  message: '成功',
                  description: '编辑计划成功',
                });
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [];
